import type { DeleteFileByIdRequest, DeleteFileByIdResponse } from "../types";
import { rootApi } from "../../../api";

export type UploadFileResponse = {
  fileId: string;
  fileName: string;
  type: string;
  createdDate: string;
};

const fileApi = rootApi.injectEndpoints({
  endpoints: (build) => ({
    uploadFile: build.mutation<UploadFileResponse, FormData>({
      query: (file) => ({
        url: "/file",
        method: "POST",
        body: file,
      }),
      invalidatesTags: ["file", "person", "note", "sync"],
    }),
    getFile: build.query<Blob, { id: string }>({
      query: ({ id }) => ({
        url: `/file/${id}`,
        method: "GET",
        responseHandler: (res) => res.blob(),
      }),
    }),
    deleteFileById: build.mutation<DeleteFileByIdResponse, DeleteFileByIdRequest>({
      query: ({ fileId }) => ({
        url: `file/${fileId}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const { useUploadFileMutation, useLazyGetFileQuery, useDeleteFileByIdMutation } = fileApi;
